import useNavigation from './useNavigation'

export * from './useNavigation'
export default useNavigation
